import {
  BOOKING_STATUS_CANCELLED,
  BOOKING_STATUS_CONFIRMED,
  BOOKING_STATUS_PENDING,
  categorizeBookingStatus,
  normalizeBookingStatus
} from '../lib/booking.js'

/**
 * Zusätzliche Roh-Status-Werte aus .env (kommagetrennt), die nicht blockieren.
 * Beispiel: VUE_APP_BOOKING_NON_BLOCKING_STATUSES="Storniert,STORNIERT"
 */
const EXTRA_NON_BLOCKING = (process.env.VUE_APP_BOOKING_NON_BLOCKING_STATUSES || '')
  .split(/[,;]/)
  .map((entry) => normalizeBookingStatus(entry))
  .filter(Boolean)

/** Alle Status-Strings, die im Kalender / bei checkAvailability ignoriert werden. */
export const NON_BLOCKING_STATUS_VALUES = [
  ...BOOKING_STATUS_CANCELLED,
  ...EXTRA_NON_BLOCKING
]

export const BLOCKING_AVAILABILITY_KINDS = ['confirmed', 'pending']

export function getAvailabilityKind(status) {
  return categorizeBookingStatus(status)
}

export function isNonBlockingBookingStatus(status) {
  const normalized = normalizeBookingStatus(status)
  if (!normalized) return false

  if (NON_BLOCKING_STATUS_VALUES.some((value) => normalized === value || normalized.includes(value))) {
    return true
  }

  return getAvailabilityKind(status) === 'cancelled'
}

export function isBlockingBookingStatus(status) {
  return !isNonBlockingBookingStatus(status) && BLOCKING_AVAILABILITY_KINDS.includes(getAvailabilityKind(status))
}

export function bookingRangesOverlap(existingStart, existingEnd, requestStart, requestEnd) {
  const startA = existingStart instanceof Date ? existingStart : new Date(existingStart)
  const endA = existingEnd instanceof Date ? existingEnd : new Date(existingEnd)
  const startB = requestStart instanceof Date ? requestStart : new Date(requestStart)
  const endB = requestEnd instanceof Date ? requestEnd : new Date(requestEnd)

  if ([startA, endA, startB, endB].some((date) => Number.isNaN(date.getTime()))) {
    return false
  }

  return startA < endB && endA > startB
}

export const BOOKING_STATUS_LABELS = {
  confirmed: BOOKING_STATUS_CONFIRMED,
  pending: BOOKING_STATUS_PENDING,
  cancelled: BOOKING_STATUS_CANCELLED
}
